<template>
  <div id="tour-timetable-page" class="flex flex-1 space-x-2 ">

    <DashboardHeaderTab :title="'Timetable'" :tabs="tabs" :activeTab="activeTab" :setActiveTab="setActiveTab"
      :toggleSidebar="toggleSidebar" />

  </div>
</template>

<script setup lang="ts">
import ClassroomTimetable from '@/components/DashBoard/Timetable/ClassroomTimetable.vue';
import TimetableTemplates from '@/components/DashBoard/Timetable/TimetableTemplates.vue';
import TeacherWorkloadView from '@/components/DashBoard/Timetable/TeacherWorkloadView.vue';
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import { useTabs } from '@/composables/useTabs';
import { can, AppPermissions } from '@/utils/permissions';
import { useUserStore } from '@/store/userStore';

const toggleSidebar = inject<() => void>('toggleSidebar', () => { });
const userStore = useUserStore();

const tabs = computed(() => {
  const user = userStore.currentUser;
  const items: Array<{ name: string; component: Component; query: string; icon?: string; group?: string }> = [];

  items.push({ name: 'Class Schedule', component: markRaw(ClassroomTimetable), query: '', icon: 'pi-calendar', group: 'schedule' });
  items.push({ name: 'Staff Workload', component: markRaw(TeacherWorkloadView), query: 'workload', icon: 'pi-user', group: 'schedule' });

  if (can(user, AppPermissions.TimeTable.Actions.Create, AppPermissions.TimeTable.Resource)
    || can(user, AppPermissions.TimeTable.Actions.Update, AppPermissions.TimeTable.Resource)) {
    items.push({ name: 'Configuration', component: markRaw(TimetableTemplates), query: 'config', icon: 'pi-cog', group: 'setup' });
  }

  return items;
});

const { activeTab, setActiveTab } = useTabs(tabs);

</script>

<style></style>
